/**
 * Legacy CustomFieldsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.customFieldsApi`) keep resolving.
 *
 * The actual CustomFieldsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/custom-fields/custom-fields-api.service.ts
 */
angular.module("acme.common.service.customFieldsApi", [
  "acme.common.factory.QueryStringBuilder",
  "acme.common.factory.apiVersion",
]);
